import styled from 'styled-components/native';

import Button from '@src/components/Button';

const Component = styled(Button).attrs(({ theme }) => ({
  mode: 'contained',
  uppercase: false,
  labelStyle: {
    color: theme.colors.onPrimary,
  },
  icon: 'arrow-left',
}))`
  margin-horizontal: 10px;
  margin-bottom: 10px;
`;

Component.displayName = 'AuthenticationSendButton';

export default Component;
